import { render, staticRenderFns } from "./VirtualList.vue?vue&type=template&id=553291eb&scoped=true"
import script from "./VirtualList.vue?vue&type=script&lang=js"
export * from "./VirtualList.vue?vue&type=script&lang=js"
import style0 from "./VirtualList.vue?vue&type=style&index=0&id=553291eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553291eb",
  null
  
)

export default component.exports